import { WeeklyDatePicker } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo } from 'react';
import { useConfig } from '../../../../contexts/config-context';
import { useTranslation } from '../../../../contexts/translation-context';
import { getFirstDayOfTheWeek } from '../../../../date-localization/get-first-day-of-the-week';
import { isSameDay } from '../../utils/format-timezone';
import { classes } from './datepicker.st.css';
import { Indicators } from './indicators';
const isAvailable = (date, availableDates) => {
  return availableDates.some(slot => {
    var _slot$slot;
    return isSameDay(new Date((_slot$slot = slot.slot) == null ? void 0 : _slot$slot.startDate), date);
  });
};
const renderIndication = _ref => {
  let {
    date,
    isSelected,
    availableDates,
    isReloadingSlots
  } = _ref;
  if (!isReloadingSlots && !isSelected && isAvailable(date, availableDates)) {
    return /*#__PURE__*/React.createElement(Indicators, null);
  }
  return null;
};
export const DatePicker = _ref2 => {
  let {
    availableDates,
    selectedDate,
    onDateChange,
    disabled,
    onWeekChange
  } = _ref2;
  const {
    language
  } = useConfig();
  const {
    t
  } = useTranslation();
  const firstDayOfWeek = useMemo(() => getFirstDayOfTheWeek(language), [language]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    onBlur: e => {
      e.stopPropagation();
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(WeeklyDatePicker, {
    className: classes.datepicker,
    leftArrowAriaLabel: t('form.appointment.accessibility.calendar.previous-week.aria-label'),
    rightArrowAriaLabel: t('form.appointment.accessibility.calendar.next-week.aria-label'),
    value: selectedDate,
    onChange: date => onDateChange && !disabled && selectedDate && !isSameDay(new Date(date), selectedDate) && onDateChange(new Date(date)),
    excludePastDates: true,
    firstDayOfWeek: firstDayOfWeek,
    removeOuterPadding: true,
    onDisplayedWeekChange: _ref3 => {
      let {
        startOfWeek,
        endOfWeek
      } = _ref3;
      return onWeekChange && onWeekChange(startOfWeek, endOfWeek);
    },
    filterDate: date => !(disabled && selectedDate && !isSameDay(date, selectedDate)),
    locale: language,
    dateIndication: _ref4 => {
      let {
        date,
        isSelected
      } = _ref4;
      return renderIndication({
        date,
        isSelected,
        availableDates: availableDates,
        isReloadingSlots: disabled
      });
    }
  }));
};
//# sourceMappingURL=datepicker-wut.js.map